<template>
  <div class="content">
    <a @click="openEnvelope"
       style="text-decoration: underline; cursor: pointer"
       v-tooltip.bottom="'Open ' + params.value">
      {{params.data.EnvelopeNumber}}
    </a>
  </div>
</template>

<script>

import { EventBus } from '@/event-bus'
import events from '@/core/events/events'

export default {
  methods: {
    async openEnvelope() {
      let envelope = (this.params && this.params.data && this.params.data.EnvelopeId) ? await this.getEnvelope(this.params.data.EnvelopeId) : this.params.data
      await this.updateUrlWithEnvelopeId(envelope.Id)
      await EventBus.$emit(events.EVEDPAY_CARDS.OPEN_ENVELOPE, envelope)
    },

    async getEnvelope(envelopeId) {
      try {
        const response = await this.api.forms.post(this.api.$.evedpaycard.envelopes, {
          sort: 'CreatedDate',
          dir: 'ASC',
          start: 0,
          limit: 100,
          isLiveGrid: true,
          filter: JSON.stringify({ 'EnvelopeId': envelopeId, searchTerm: '' })
        })

        if (response && response.data) {
          return response.data.Data[0]
        }
      } catch (error) {
        console.error('Error while retrieving envelopes:', error)
      }
    },

    async updateUrlWithEnvelopeId(envelopeId) {
      var basePath = ''
      if (this.$user.$.userPermissions.includes('ApprovalDashboard')) {
        basePath = '#/d/EnvelopeApprovalDashboard'
      } else {
        basePath = '#/d/Programs/>Card/envelopes'
      }
      const queryParam = `EnvelopeId=${envelopeId}`
      const newUrl = `${basePath}?${queryParam}`
      window.history.pushState({}, '', newUrl)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-envelopes/OpenEnvelope.vue